import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import type { RsvpQuestion } from '@bridebook/web/lib/rsvp/types';

export const useGetPopularRsvpQuestions = (): RsvpQuestion[] => {
  const { t } = useTranslation('weddingWebsite');

  return useMemo(
    () => [
      {
        // What is your meal choice?
        question: t('rsvp.form.popularQs.mealChoice.title'),
        type: 'list',
        // Free range roast chicken, Filet mignon steak, Wild mushroom risotto
        options: t('rsvp.form.popularQs.mealChoice.options').split(', '),
      },
      {
        question: t('rsvp.form.popularQs.dietaryRestrictions.title'),
        type: 'list',
        options: t('rsvp.form.popularQs.dietaryRestrictions.options').split(', '),
      },
      {
        question: t('rsvp.form.popularQs.songRequests.title'),
        type: 'string',
      },
      {
        question: t('rsvp.form.popularQs.plusOne.title'),
        type: 'boolean',
      },
    ],
    [t],
  );
};
